// Third Party Imports
import React from 'react';
import {RadioButton, RadioGroup} from '@homeaway/react-form-components';

// Relative import
import ContinueButtonHolder from '../ButtonHolder/ContinueButtonHolder';
import Address from '../Address/Address';
import AlertBox from '../Alert/Alert';
import {getSelectOptions} from '../utils/addressUtil';
import SubHead from '../SubHead/SubHead';
import './MailingInformation.less';
import {isUsSite} from '../../utils/validate';
import {
    handleFormFields,
    handleFormFieldsOnBlur,
    addressFormValuesMapper,
    addressFormErrorMapper
} from '../utils/addressUtil';
import {ADDRESS_TYPE_MAILING, ADDRESS_TYPE_BILLING} from '../../utils/constants';
import {isPortugueseSite} from '../../utils/validate';


class MailingInformation extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }


    handleMailingAddressFields = (event) => {
        return handleFormFields(event, {
            handleCountryChange: this.props.handleMailingCountryChange,
            handleAddressLine1Change: this.props.handleMailingAddressLine1Change,
            handleAddressLine2Change: this.props.handleMailingAddressLine2Change,
            handleCityChange: this.props.handleMailingCityChange,
            handleStateChange: this.props.handleMailingStateChange,
            handleSelectStateChange: this.props.handleMailingSelectStateChange,
            handlePostalCodeChange: this.props.handleMailingPostalCodeChange
        });
    };

    handleBillingAddressFields = (event) => {
        return handleFormFields(event, {
            handleCountryChange: this.props.handleBillingCountryChange,
            handleAddressLine1Change: this.props.handleBillingAddressLine1Change,
            handleAddressLine2Change: this.props.handleBillingAddressLine2Change,
            handleCityChange: this.props.handleBillingCityChange,
            handleStateChange: this.props.handleBillingStateChange,
            handleSelectStateChange: this.props.handleBillingSelectStateChange,
            handlePostalCodeChange: this.props.handleBillingPostalCodeChange
        });
    };

    handleMailingFieldsOnBlur = (event) => {
        return handleFormFieldsOnBlur(event, {
            onCountryBlur: this.props.onMailingCountryBlur,
            onAddress1Blur: this.props.onMailingAddress1Blur,
            onAddress2Blur: this.props.onMailingAddress2Blur,
            onCityBlur: this.props.onMailingCityBlur,
            onStateBlur: this.props.onMailingStateBlur,
            onSelectedStateBlur: this.props.onMailingSelectedStateBlur,
            onPostalCodeBlur: this.props.onMailingPostalCodeBlur
        });
    };

    handleBillingFieldsOnBlur = (event) => {
        return handleFormFieldsOnBlur(event, {
            onCountryBlur: this.props.onBillingCountryBlur,
            onAddress1Blur: this.props.onBillingAddress1Blur,
            onAddress2Blur: this.props.onBillingAddress2Blur,
            onCityBlur: this.props.onBillingCityBlur,
            onStateBlur: this.props.onBillingStateBlur,
            onSelectedStateBlur: this.props.onBillingSelectedStateBlur,
            onPostalCodeBlur: this.props.onBillingPostalCodeBlur
        });
    };

    setAddressFormValues = (addressType) => {
        return addressFormValuesMapper({
            addressLine1Val: this.props[`${addressType}AddressLine1`],
            addressLine2Val: this.props[`${addressType}AddressLine2`],
            cityVal: this.props[`${addressType}City`],
            stateVal: this.props[`${addressType}State`],
            stateSelectVal: this.props[`${addressType}State`],
            postalCodeVal: this.props[`${addressType}PostalCode`],
            translations: this.props.translations,
            addressType
        });
    }

    setAddressFormErrors = (addressType) => {
        return addressFormErrorMapper({
            countryError: this.props[`${addressType}CountryError`],
            addressLine1Error: this.props[`${addressType}AddressLine1Error`],
            cityError: this.props[`${addressType}CityError`],
            stateError: this.props[`${addressType}StateError`],
            postalCodeError: this.props[`${addressType}PostalCodeError`],
            translations: this.props.translations,
            addressType
        });
    }

    render() {
        let {
            translations,
            siteName,
            handleFormSubmit,
            mailingMetadata,
            serviceError,
            handleAlertDismiss,
            enableButton,
            handleSaveAndFinishOnClick,
            isSaveModalOpen,
            handleSaveModalClose,
            triggerEdapEventOnFocus,

            mailingCountry,
            billingCountry,

            handleChoiceChange,
            choice
        } = this.props;

        const countryOptions = getSelectOptions(mailingMetadata.countryList);

        let extendedStyle = '';
        if (isPortugueseSite(siteName)) {
            extendedStyle = '-extended';
        }

        return (<div id="mailingInformation" className="mailing-information">
            <div className="mailing-information-container">
                <SubHead
                    translations={translations}
                    handleSaveAndFinishOnClick={handleSaveAndFinishOnClick}
                    isSaveModalOpen={isSaveModalOpen}
                    handleSaveModalClose={handleSaveModalClose}
                />
                {
                    (serviceError)
                        ? <div className="alert-panel">
                            <AlertBox
                                messageKey={serviceError}
                                translations={translations}
                                handleAlertDismiss={handleAlertDismiss}
                                size={'sm'}
                            />
                        </div>
                        : null
                }
                <div className="panel-head">
                    <h1 className="head">{translations['ipmob.mailing_address.heading']}</h1>
                    {
                        (isUsSite(siteName)) ? null : <span className="header-description">{translations['ipmob.mailing_address.header_desc']}</span>
                    }
                </div>
                <form id="mailing_addressForm" role="form">
                    <div className="input-container" aria-label="Big form">
                        <div className="wrapper">
                            <div className="content-col">
                                <h5 className="sub-head">
                                    {translations['ipmob.mailing_address.sub_heading']}
                                </h5>
                            </div>
                        </div>
                        <Address
                            countryList={countryOptions}
                            country={mailingCountry}
                            translations={translations}
                            addressFormValues={this.setAddressFormValues(ADDRESS_TYPE_MAILING)}
                            addressFormErrors={this.setAddressFormErrors(ADDRESS_TYPE_MAILING)}
                            handleFieldsOnBlur={this.handleMailingFieldsOnBlur}
                            handleAddressFields={this.handleMailingAddressFields}
                            handleFieldsOnFocus={triggerEdapEventOnFocus}
                            addressType={ADDRESS_TYPE_MAILING}
                        />
                    </div>
                </form>

                <div className="wrapper">
                    <div className="content-col-text billing-sub-head">
                        <h3>{translations['ipmob.billing_page.sub_heading_3']}</h3>
                    </div>
                </div>
                <div className="wrapper">
                        <div className={`address-choice content-col${extendedStyle}`}>
                            <RadioGroup name="choice" ariaLabel="Address choices for mailing and billing addresses">
                                <RadioButton
                                    id="mailingAddressChoice"
                                    label={translations['ipmob.billing_address.choice1']}
                                    value="Mailing address"
                                    onChange={handleChoiceChange}
                                    size="sm"
                                    checked={choice === 'Mailing address'}
                                    type={'radio'}
                                />
                                <RadioButton
                                    id="billingAddressChoice"
                                    label={translations['ipmob.billing_address.choice2']}
                                    value="Billing address"
                                    onChange={handleChoiceChange}
                                    size="sm"
                                    checked={choice === 'Billing address'}
                                    type={'radio'}
                                />
                            </RadioGroup>
                        </div>
                    </div>
                    <form id="billing_addressForm" role="form">
                        <div className="input-container" aria-label="Big form">
                            <div className="address-holder">
                                {
                                    <Address
                                        translations={translations}
                                        countryList={countryOptions}
                                        country={billingCountry}
                                        addressFormValues={this.setAddressFormValues(ADDRESS_TYPE_BILLING)}
                                        addressFormErrors={this.setAddressFormErrors(ADDRESS_TYPE_BILLING)}
                                        handleFieldsOnBlur={this.handleBillingFieldsOnBlur}
                                        handleAddressFields={this.handleBillingAddressFields}
                                        extendedStyle={extendedStyle}
                                        handleFieldsOnFocus={triggerEdapEventOnFocus}
                                        addressType={ADDRESS_TYPE_BILLING}
                                    />
                                }
                            </div>
                        </div>
                    </form>
                <ContinueButtonHolder
                    enableContinueButton={enableButton}
                    translations={translations}
                    handleContinueButtonClick={handleFormSubmit}
                    continueButtonId={'mailingAddressPageContinueBtn'}
                />
            </div>
        </div>);
    }
}

export default MailingInformation;
